import { EventRegistryCategory } from '../../EventRegistryCategory';
import { EventRegistryItem } from '../../EventRegistryItem';
export class EventRegistryReactMedia extends EventRegistryCategory {
    label = 'Media Events';
    constructor(parent) {
        super(parent);
        super.init();
    }
    abort = () => new EventRegistryItem({ handlerName: 'onAbort' });
    canplay = () => new EventRegistryItem({ handlerName: 'onCanPlay' });
    canplaythrough = () => new EventRegistryItem({ handlerName: 'onCanPlayThrough' });
    durationchange = () => new EventRegistryItem({ handlerName: 'onDurationChange' });
    emptied = () => new EventRegistryItem({ handlerName: 'onEmptied' });
    encrypted = () => new EventRegistryItem({ handlerName: 'onEncrypted' });
    ended = () => new EventRegistryItem({ handlerName: 'onEnded' });
    load = () => new EventRegistryItem({ handlerName: 'onLoad' });
    error = () => new EventRegistryItem({ handlerName: 'onError' });
    loadeddata = () => new EventRegistryItem({ handlerName: 'onLoadedData' });
    loadedmetadata = () => new EventRegistryItem({ handlerName: 'onLoadedMetadata' });
    loadstart = () => new EventRegistryItem({ handlerName: 'onLoadStart' });
    pause = () => new EventRegistryItem({ handlerName: 'onPause' });
    play = () => new EventRegistryItem({ handlerName: 'onPlay' });
    playing = () => new EventRegistryItem({ handlerName: 'onPlaying' });
    progress = () => new EventRegistryItem({ handlerName: 'onProgress' });
    ratechange = () => new EventRegistryItem({ handlerName: 'onRateChange' });
    seekend = () => new EventRegistryItem({ handlerName: 'onSeeked' });
    seeking = () => new EventRegistryItem({ handlerName: 'onSeeking' });
    stalled = () => new EventRegistryItem({ handlerName: 'onStalled' });
    suspend = () => new EventRegistryItem({ handlerName: 'onSuspend' });
    timeupdate = () => new EventRegistryItem({ handlerName: 'onTimeUpdate' });
    volumechange = () => new EventRegistryItem({ handlerName: 'onVolumeChange' });
    waiting = () => new EventRegistryItem({ handlerName: 'onWaiting' });
}
